import { useTranslation } from "react-i18next"
import { CheckBox, CheckBoxProps } from "../checkBox/CheckBox"
import './TermCheckBox.css'
import {ReactComponent as IcNext} from '../../../assets/svgs/icon/ic_next_24.svg'
import { BottomSheet } from "../bottomSheet/BottomSheet"
import { useState } from "react"
import { Button } from "../button/Button"
import { palette } from "common/commonStyle"

interface TermCheckBoxProps extends CheckBoxProps {
    isRequired?: boolean
}

export const TermCheckBox = ({isRequired, ...rest} : TermCheckBoxProps) => {
    const {t} = useTranslation();
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="term-checkbox">
            <span style={{display: "flex", flexDirection: "row", alignItems: "center", gap: "4px"}}>
                <CheckBox
                    {...rest}
                />
                {isRequired &&
                    <span className="required">{t("required")}</span>
                }
            </span>
            <IcNext
                className="ic-open-term"
                onClick={() => {
                    setIsOpen(true)
                }}
                height="20px"
                width="20px"
            />
            <BottomSheet
                isOpen={isOpen}
                setIsOpen={setIsOpen}
            >
                <div className="term-container">
                    <div className="term-info">
                        <div className="term-title">
                            {rest.title}
                        </div>
                        <div className="term-text">
                            약관내용
                        </div>
                    </div>
                    <div className="term-btn-container">
                        <Button
                            buttonColor={palette.fixedBlack}
                            text={t("term.btnClose")}
                            onPress={() => {setIsOpen(false)}}
                        />
                        <Button
                            text={t("term.btnAgree")}
                            onPress={() => {
                                setIsOpen(false)
                                rest.setChecked(true)
                            }}
                        />

                    </div>
                    
                </div>
            </BottomSheet>
            
            
        </div>
    )
}